import { render } from "./RepositoryPage.vue?vue&type=template&id=6ab403aa&ts=true"
import script from "./RepositoryPage.vue?vue&type=script&lang=ts"
export * from "./RepositoryPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/Admin/Repository/RepositoryPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6ab403aa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6ab403aa', __exports__)) {
    api.reload('6ab403aa', __exports__)
  }
  
  module.hot.accept("./RepositoryPage.vue?vue&type=template&id=6ab403aa&ts=true", () => {
    api.rerender('6ab403aa', render)
  })

}


export default __exports__